/* Gleva · Direction B · gvb-ticker.js — the promise ticker (port of final-b2/_src/home.js "09 promise ticker").
   Moves only with scroll. When scrolling stops it eases to the nearest whole phrase, so the left edge always starts
   on a complete phrase; the right edge fades. Reduced motion: static list (.is-static). */
import { G } from 'gvb';

const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

function boot(track) {
  if (track._gvbT) return;
  track._gvbT = true;
  const tick = track.closest('.ticker');
  if (G.reduce) { tick.classList.add('is-static'); return; }
  const sec = track.closest('.shopify-section') || tick;
  const speed = Number(tick.dataset.speed) || 0.32;
  const items = $$('.ticker-item', track), perCopy = $$('.ticker-item:not([data-dup])', track).length;
  let pos = [], unit = 1, shift = 0, cur = 0, settleT = null, ticking = false;
  const measure = () => {
    const pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    pos = items.map((el) => el.offsetLeft - pad);
    unit = (pos[perCopy] - pos[0]) || track.scrollWidth / 3;
  };
  const place = (x, ease) => {
    track.style.transition = ease ? 'transform .45s cubic-bezier(.2,.7,.2,1)' : 'none';
    track.style.transform = 'translate3d(' + (-x).toFixed(1) + 'px,0,0)';
  };
  const move = () => {
    const r = sec.getBoundingClientRect();
    const p = Math.max(0, window.innerHeight - r.top) * speed;
    cur = (((p + shift) % unit) + unit) % unit;
    place(cur, false);
  };
  const settle = () => {
    let best = pos[0];
    pos.forEach((x) => { if (Math.abs(x - cur) < Math.abs(best - cur)) best = x; });
    shift += best - cur; cur = best;
    place(best, true);
  };
  window.addEventListener('scroll', () => {
    clearTimeout(settleT); settleT = setTimeout(settle, 160);
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => { move(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', () => { measure(); move(); settle(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { measure(); move(); });
  measure(); move();
}

const init = (scope) => $$('[data-ticker]', scope).forEach(boot);
init(document);
document.addEventListener('shopify:section:load', (e) => init(e.target));
